export const visible = (element: HTMLElement, binding: any) => {
  element.style.visibility = !!binding.value ? 'visible' : 'hidden';
};
